import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'مدیریت دانش بهسازان ملت',
    shortName: 'مدیریت دانش',
    organization: 'بهسازان ملت',
    description: 'سامانه مدیریت دانش سازمانی بهسازان ملت؛ مرکز ثبت، سازمان‌دهی، جست‌وجو و اشتراک دانش تخصصی، تجربیات پروژه‌ها، دستورالعمل‌ها و آموزش‌های همکاران.',
    url: getOrigin()
}
